/* GripLux 2.0 — interaction layer (gx-core.js). Vanilla, no dependencies. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------------- storage (safe) ---------------- */
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------------- phone catalog ---------------- */
  var DATA = null;
  function data() {
    if (DATA) return DATA;
    var el = d.getElementById('gx-phone-data');
    try { DATA = JSON.parse(el.textContent); } catch (e) { DATA = { brands: [], cats: [] }; }
    DATA.index = {};
    DATA.brands.forEach(function (b) { b.series.forEach(function (s) { s.models.forEach(function (m) { m.brand = b.id; DATA.index[m.h] = m; }); }); });
    return DATA;
  }
  var GX = w.GX = w.GX || {};
  GX.getPhone = function () { var p = store.get('gx_phone'); return p && p.h ? p : null; };
  GX.setPhone = function (m) {
    if (!m) { store.del('gx_phone'); } else { store.set('gx_phone', { h: m.h, n: m.n, brand: m.brand }); }
    d.dispatchEvent(new CustomEvent('gx:phone', { detail: GX.getPhone() }));
  };

  /* ---------------- helpers ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function onIdle(fn) { (w.requestIdleCallback || function (f) { return setTimeout(f, 60); })(fn); }
  function toast(html) {
    var t = $('.gx-toast');
    if (!t) { t = d.createElement('div'); t.className = 'gx-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  }
  GX.toast = toast;

  /* ---------------- cart (works with Concept's pubsub) ---------------- */
  GX.addToCart = function (variantId, qty, meta) {
    var sections = [];
    d.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var body = { items: [{ id: variantId, quantity: qty || 1 }] };
    if (sections.length) { body.sections = sections; body.sections_url = w.location.pathname; }
    var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (state) {
        try {
          if (w.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              if (state.sections) cart.sections = state.sections;
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gx-quick-add', cart: cart, productVariantId: variantId });
              return state;
            });
          }
        } catch (e) {}
        return state;
      })
      .then(function (state) {
        var img = meta && meta.img ? '<img src="' + esc(meta.img) + '" alt="">' : '';
        toast(img + '<span><b>Added</b> — ' + esc(meta && meta.t ? meta.t : 'item') + '</span>');
        var btn = $('[aria-controls="CartDrawer"]') || $('a[href$="/cart"]');
        if (btn && w.theme && theme.settings && theme.settings.cartType === 'drawer') { try { btn.click(); } catch (e) {} }
        return state;
      });
  };

  /* ---------------- product card html ---------------- */
  GX.card = function (p, phone) {
    var fit = phone && p.f ? '<span class="gx-card__fit">' + CHECK.replace('<svg', '<svg width="12" height="12"') + ' Fits ' + esc(phone.n) + '</span>' : '';
    var img2 = p.i2 ? '<img src="' + esc(p.i2) + '" alt="" loading="lazy" width="600" height="600">' : '';
    return '<a class="gx-card" href="' + esc(p.u) + '" data-gx-tilt>' + fit +
      '<div class="gx-card__media">' + (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="600" height="600">' : '') + img2 +
      (p.a ? '<button type="button" class="gx-card__add" data-gx-add="' + p.v + '" aria-label="Add ' + esc(p.t) + ' to cart">' + PLUS + '</button>' : '') + '</div>' +
      '<div class="gx-card__body"><div class="gx-card__title">' + esc(p.t) + '</div>' +
      '<div class="gx-card__price">' + esc(p.p) + (p.c ? ' <s>' + esc(p.c) + '</s>' : '') + '</div></div></a>';
  };
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gx-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-loading')) return;
    var card = b.closest('.gx-card');
    var meta = card ? { t: ($('.gx-card__title', card) || {}).textContent, img: (($('img', card) || {}).src) } : {};
    b.classList.add('is-loading');
    GX.addToCart(+b.getAttribute('data-gx-add'), 1, meta).then(function () {
      b.classList.remove('is-loading'); b.classList.add('is-done'); b.innerHTML = CHECK;
      setTimeout(function () { b.classList.remove('is-done'); b.innerHTML = PLUS; }, 2200);
    }).catch(function (err) {
      b.classList.remove('is-loading');
      toast('<span>' + esc((err && (err.description || err.message)) || 'Could not add — pick options on the product page') + '</span>');
    });
  }, true);

  /* ---------------- collection JSON loader ---------------- */
  var cache = {};
  GX.loadCollection = function (handle, page) {
    var key = handle + ':' + (page || 1);
    if (cache[key]) return cache[key];
    var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cache[key] = fetch(root + 'collections/' + handle + '?view=gx-json&page=' + (page || 1), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var j = JSON.parse(t); if (!j || !j.products) throw new Error('bad collection json'); return j; })
      .catch(function (e) { delete cache[key]; throw e; });
    return cache[key];
  };

  /* ---------------- reveal + split text ---------------- */
  function split(el) {
    if (el.dataset.gxSplitDone) return;
    el.dataset.gxSplitDone = 1;
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = d.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
            var o = d.createElement('span'); o.className = 'w';
            var inner = d.createElement('span'); inner.textContent = part; inner.style.setProperty('--i', i++);
            o.appendChild(inner); frag.appendChild(o);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    }
    walk(el);
  }
  function initReveal(scope) {
    $$('[data-gx-split]', scope).forEach(function (el) { el.classList.add('gx-split'); split(el); });
    var els = $$('[data-gx-reveal],[data-gx-split]', scope);
    if (reduce || !('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- counters ---------------- */
  function initCounters(scope) {
    $$('[data-gx-count]', scope).forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-gx-count')) || 0, done = false;
      var run = function () {
        if (done) return; done = true;
        if (reduce) { el.textContent = to.toLocaleString(); return; }
        var t0 = performance.now(), dur = 1600;
        (function tick(t) { var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 4); el.textContent = Math.round(to * k).toLocaleString(); if (k < 1) requestAnimationFrame(tick); })(t0);
      };
      if (!('IntersectionObserver' in w)) return run();
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---------------- magnetic buttons + tilt + spotlight ---------------- */
  function initPointer(scope) {
    if (!fine || reduce) return;
    $$('.gx-btn', scope).forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        b.style.setProperty('--mx', x + 'px'); b.style.setProperty('--my', y + 'px');
        b.style.transform = 'translate(' + ((x - r.width / 2) * 0.18) + 'px,' + ((y - r.height / 2) * 0.28) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
    $$('.gx-tile', scope).forEach(function (t) {
      t.addEventListener('pointermove', function (e) {
        var r = t.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        t.style.setProperty('--tx', (x * 100) + '%'); t.style.setProperty('--ty', (y * 100) + '%');
        t.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 6) + 'deg) rotateY(' + ((x - 0.5) * 8) + 'deg)';
      });
      t.addEventListener('pointerleave', function () { t.style.transform = ''; });
    });
    $$('[data-gx-spot]', scope).forEach(function (s) {
      var sp = $('.gx-spot', s);
      if (!sp) return;
      s.addEventListener('pointermove', function (e) {
        var r = s.getBoundingClientRect();
        sp.style.setProperty('--sx', ((e.clientX - r.left) / r.width * 100) + '%');
        sp.style.setProperty('--sy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
    $$('[data-gx-phone3d]', scope).forEach(function (stage) {
      var ph = $('.gx-phone', stage);
      if (!ph) return;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        ph.style.setProperty('--ry', (-24 + x * 40) + 'deg'); ph.style.setProperty('--rx', (8 - y * 24) + 'deg');
      });
      stage.addEventListener('pointerleave', function () { ph.style.removeProperty('--ry'); ph.style.removeProperty('--rx'); });
    });
  }

  /* ---------------- rails (drag + arrows + progress) ---------------- */
  function initRails(scope) {
    $$('[data-gx-rail]', scope).forEach(function (rail) {
      if (rail.dataset.gxRailDone) return; rail.dataset.gxRailDone = 1;
      var track = $('.gx-rail__track', rail), bar = $('.gx-rail__bar i', rail);
      if (!track) return;
      var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
      $$('[data-gx-prev]', rail).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); }); });
      $$('[data-gx-next]', rail).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); }); });
      var upd = function () {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth, vis = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(10, vis * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(vis, .1)) - 1) * 100 : 0) + '%)';
      };
      track.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); setTimeout(upd, 300);
      if (fine) {
        var down = false, sx = 0, sl = 0, moved = false;
        track.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
        w.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
        w.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 30); });
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      }
    });
  }

  /* ---------------- async product rails ---------------- */
  function initAsyncRails(scope) {
    $$('[data-gx-rail-src]', scope).forEach(function (rail) {
      if (rail.dataset.gxLoaded) return; rail.dataset.gxLoaded = 1;
      var track = $('.gx-rail__track', rail), handle = rail.getAttribute('data-gx-rail-src'), limit = +rail.getAttribute('data-limit') || 12;
      var load = function () {
        GX.loadCollection(handle, 1).then(function (j) {
          var phone = GX.getPhone();
          var items = (j.products || []).filter(function (p) { return p.i; }).slice(0, limit);
          if (!items.length) { rail.closest('.gx-section') && (rail.closest('.gx-section').style.display = 'none'); return; }
          track.innerHTML = items.map(function (p) { return GX.card(p, null); }).join('');
          initRails(rail);
        }).catch(function () { var s = rail.closest('.gx-section'); if (s) s.style.display = 'none'; });
      };
      if ('IntersectionObserver' in w) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px' });
        io.observe(rail);
      } else load();
    });
  }

  /* ---------------- marquee duplication ---------------- */
  function initMarquee(scope) {
    $$('.gx-marquee', scope).forEach(function (m) {
      if (m.dataset.gxDone) return; m.dataset.gxDone = 1;
      var t = $('.gx-marquee__track', m); if (!t) return;
      var c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); m.appendChild(c);
    });
  }

  /* ---------------- scroll story ---------------- */
  function initStory(scope) {
    $$('[data-gx-story]', scope).forEach(function (st) {
      var steps = $$('.gx-story__step', st), dots = $$('.gx-story__dots i', st), vis = $('.gx-story__visual', st);
      var n = steps.length;
      var onScroll = function () {
        var r = st.getBoundingClientRect(), total = st.offsetHeight - w.innerHeight;
        var p = Math.min(1, Math.max(0, -r.top / Math.max(total, 1)));
        var idx = Math.min(n - 1, Math.floor(p * n));
        steps.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); });
        dots.forEach(function (dd, i) { dd.style.setProperty('--p', Math.min(1, Math.max(0, p * n - i))); });
        var seg = function (a, b) { return Math.min(1, Math.max(0, (p - a) / (b - a))); };
        if (vis) {
          vis.style.setProperty('--grip', seg(0.05, 0.3));
          vis.style.setProperty('--cable', seg(0.4, 0.62));
          vis.style.setProperty('--stand', seg(0.72, 0.92));
          var ph = $('.gx-phone', vis);
          if (ph && !reduce) { ph.style.setProperty('--ry', (-18 + p * 50) + 'deg'); ph.style.setProperty('--rx', (6 - p * 10) + 'deg'); }
        }
      };
      w.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    });
  }

  /* ---------------- power lab ---------------- */
  function initLab(scope) {
    $$('[data-gx-lab]', scope).forEach(function (lab) {
      var devs = $$('.gx-dev', lab), out = $('[data-gx-watts]', lab), arc = $('.gx-meter__val', lab), rec = $('[data-gx-rec]', lab);
      var recs = []; try { recs = JSON.parse(($('script[data-gx-recs]', lab) || {}).textContent || '[]'); } catch (e) {}
      var TL = arc ? arc.getTotalLength() : 0, L = TL * 0.75, MAX = 240;
      if (arc) { arc.style.strokeDasharray = L + ' ' + TL; arc.style.strokeDashoffset = L; }
      var cur = 0;
      var calc = function () {
        var total = 0, ports = 0;
        devs.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') { total += +b.dataset.w; ports++; } });
        var t0 = performance.now(), from = cur;
        (function tick(t) { var k = Math.min(1, (t - t0) / 700); k = 1 - Math.pow(1 - k, 3); var v = Math.round(from + (total - from) * k); if (out) out.textContent = v; if (k < 1) requestAnimationFrame(tick); else cur = total; })(t0);
        if (arc) arc.style.strokeDashoffset = L * (1 - Math.min(1, total / MAX));
        if (rec) {
          var pick = null;
          recs.forEach(function (r) { if (!pick && r.w >= total && r.ports >= ports) pick = r; });
          if (!pick && recs.length) pick = recs[recs.length - 1];
          if (pick && total > 0) {
            rec.hidden = false; rec.href = pick.u;
            rec.innerHTML = (pick.i ? '<img src="' + esc(pick.i) + '" alt="" loading="lazy">' : '') + '<div><span>Your match · ' + total + 'W needed across ' + ports + ' device' + (ports > 1 ? 's' : '') + '</span><b>' + esc(pick.t) + '</b><span>' + esc(pick.p) + '</span></div>';
          } else { rec.hidden = true; }
        }
      };
      devs.forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); calc(); }); });
      calc();
    });
  }

  /* ---------------- phone finder ---------------- */
  function Finder(root) {
    var self = this, D = data();
    this.root = root;
    var brandsEl = $('.gx-brands', root), modelsEl = $('.gx-models', root), grid = $('.gx-results__grid', root),
        titleEl = $('.gx-results__title', root), catsEl = $('.gx-cats', root), footEl = $('.gx-results__foot', root), q = $('.gx-search input', root);
    var cur = GX.getPhone(), brand = cur ? cur.brand : (D.brands[0] && D.brands[0].id), cat = 'all', items = [];

    function renderBrands() {
      brandsEl.innerHTML = D.brands.map(function (b) { return '<button type="button" class="gx-brand" role="tab" aria-selected="' + (b.id === brand) + '" data-b="' + b.id + '">' + esc(b.name) + '</button>'; }).join('');
    }
    function renderModels() {
      var term = (q && q.value || '').trim().toLowerCase();
      var html = '';
      D.brands.forEach(function (b) {
        if (!term && b.id !== brand) return;
        b.series.forEach(function (s) {
          var ms = s.models.filter(function (m) { return !term || (m.n + ' ' + (m.sub || '')).toLowerCase().indexOf(term) > -1; });
          if (!ms.length) return;
          html += '<div class="gx-series"><div class="gx-series__name">' + esc(s.name) + (s.badge ? ' <span class="gx-new" style="font-size:9px;background:var(--gx-lime);color:var(--gx-ink);padding:2px 6px;border-radius:5px;letter-spacing:.08em">' + esc(s.badge) + '</span>' : '') + '</div>' +
            ms.map(function (m) {
              return '<button type="button" class="gx-model" data-h="' + m.h + '" aria-pressed="' + (cur && cur.h === m.h) + '"><span class="gx-model__icon' + (m.fold ? ' gx-model__icon--fold' : '') + '"></span><span>' + esc(m.n) + (m.sub ? '<br><small style="margin:0;opacity:.6">' + esc(m.sub) + '</small>' : '') + '</span>' + (m['new'] ? '<small class="gx-new" style="opacity:1">New</small>' : '<small>' + m.y + '</small>') + '</button>';
            }).join('') + '</div>';
        });
      });
      modelsEl.innerHTML = html || '<p style="padding:16px;opacity:.6">No match — try "18 Pro" or "Fold".</p>';
    }
    function renderCats() {
      var present = {};
      items.forEach(function (p) { if (p.k) present[p.k] = (present[p.k] || 0) + 1; });
      var chips = '<button type="button" class="gx-chip" aria-pressed="' + (cat === 'all') + '" data-c="all">All <small style="opacity:.6">' + items.length + '</small></button>';
      D.cats.forEach(function (c) { if (present[c.id]) chips += '<button type="button" class="gx-chip" aria-pressed="' + (cat === c.id) + '" data-c="' + c.id + '">' + esc(c.n) + ' <small style="opacity:.6">' + present[c.id] + '</small></button>'; });
      catsEl.innerHTML = chips;
    }
    var shown = 24;
function renderGrid(more) {
if (!more) shown = 24;
var list = items.filter(function (p) { return cat === 'all' || p.k === cat; });
      if (!list.length) { grid.innerHTML = '<p style="grid-column:1/-1;opacity:.6">Nothing in this category yet for your phone — check the others.</p>'; return; }
      var left = list.length - shown;
grid.innerHTML = list.slice(0, shown).map(function (p) { return GX.card(p, cur); }).join('') + (left > 0 ? '<div style="grid-column:1/-1;display:flex;justify-content:center;padding-top:6px"><button type="button" class="gx-btn gx-btn--sm gx-btn--ink" data-gx-more>Show ' + Math.min(48, left) + ' more <small style="opacity:.7;margin-left:6px">' + left + ' left</small></button></div>' : '');
      initPointer(grid);
    }
    function empty() {
      titleEl.innerHTML = 'Pick your phone';
      catsEl.innerHTML = '';
      grid.innerHTML = '<div class="gx-results__empty" style="grid-column:1/-1"><div><div class="gx-bigphone"></div><b style="display:block;font-size:20px;color:var(--gx-ink)">Which phone is in your hand?</b><p>Choose it on the left and we’ll show every case, grip, charger and accessory that fits.</p></div></div>';
      footEl.innerHTML = '';
    }
    function load(m) {
      cur = m; cat = 'all';
      titleEl.innerHTML = esc(m.n) + '<span>loading…</span>';
      grid.innerHTML = new Array(8).join('<div class="gx-skel"></div>');
      catsEl.innerHTML = '';
      GX.loadCollection(m.h, 1).then(function (j1) {
var pages = Math.min(+j1.pages || 1, 25), reqs = [];
for (var pg = 2; pg <= pages; pg++) reqs.push(GX.loadCollection(m.h, pg).catch(function () { return { products: [] }; }));
return Promise.all(reqs).then(function (rest) { return [j1].concat(rest); });
}).then(function (res) {
if (cur !== m) return;
var j = res[0], seen = {};
items = [];
res.forEach(function (pg) { (pg.products || []).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; items.push(p); } }); });
        items.sort(function (a, b) { return (b.f ? 1 : 0) - (a.f ? 1 : 0); });
        titleEl.innerHTML = esc(m.n) + '<span>' + (j.count || items.length) + ' accessories fit</span>';
        renderCats(); renderGrid();
        footEl.innerHTML = '<a class="gx-btn gx-btn--ink" href="/collections/' + m.h + '">See all ' + (j.count || '') + ' for ' + esc(m.n) + ' ' + ARROW + '</a>';
        initPointer(footEl);
      }).catch(function () {
        items = [];
        titleEl.innerHTML = esc(m.n);
        grid.innerHTML = '<p style="grid-column:1/-1">We’re stocking accessories for the ' + esc(m.n) + ' right now. Universal chargers, cables and creator gear fit today:</p>';
        footEl.innerHTML = '<a class="gx-btn gx-btn--ink" href="/collections/all-products">Shop everything ' + ARROW + '</a>';
      });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.gx-brand');
      if (b) { brand = b.dataset.b; if (q) q.value = ''; renderBrands(); renderModels(); return; }
      var m = e.target.closest('.gx-model');
      if (m) {
        var model = D.index[m.dataset.h]; if (!model) return;
        GX.setPhone(model); brand = model.brand;
        $$('.gx-model', root).forEach(function (x) { x.setAttribute('aria-pressed', x === m); });
        load(model);
        if (w.innerWidth < 990) { var r = $('.gx-results', root); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      var mo = e.target.closest('[data-gx-more]');
if (mo) { shown += 48; renderGrid(true); return; }
var c = e.target.closest('.gx-cats .gx-chip');
      if (c) { cat = c.dataset.c; renderCats(); renderGrid(); }
    });
    if (q) q.addEventListener('input', function () { renderModels(); });
    d.addEventListener('gx:phone', function (ev) {
      var p = ev.detail;
      if (p && (!cur || cur.h !== p.h) && D.index[p.h]) { brand = D.index[p.h].brand; renderBrands(); renderModels(); load(D.index[p.h]); }
    });
    renderBrands(); renderModels();
    if (cur && D.index[cur.h]) load(D.index[cur.h]); else empty();
  }
  function initFinders(scope) {
    $$('[data-gx-finder]', scope).forEach(function (el) { if (!el._gx) el._gx = new Finder(el); });
  }

  /* ---------------- global drawer + header chip ---------------- */
  function openDrawer() {
    var dr = $('#gx-finder-drawer');
    if (!dr) return;
    dr.classList.add('is-open'); d.documentElement.style.overflow = 'hidden';
    initFinders(dr);
    setTimeout(function () { var i = $('.gx-search input', dr); if (i && fine) i.focus(); }, 200);
  }
  function closeDrawer() {
    var dr = $('#gx-finder-drawer'); if (!dr) return;
    dr.classList.remove('is-open'); d.documentElement.style.overflow = '';
  }
  GX.openFinder = openDrawer;
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-gx-open-finder]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-gx-close-finder]')) { e.preventDefault(); closeDrawer(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  function paintChips() {
    var p = GX.getPhone();
    $$('.gx-phonechip').forEach(function (c) {
      var t = $('.gx-phonechip__txt', c);
      if (p) { c.removeAttribute('data-empty'); if (t) t.textContent = p.n; c.setAttribute('aria-label', 'Your phone: ' + p.n + '. Change phone'); }
      else { c.setAttribute('data-empty', ''); if (t) t.textContent = 'My phone'; c.setAttribute('aria-label', 'Choose your phone'); }
    });
  }
  d.addEventListener('gx:phone', function () { paintChips(); markCards(); pdpFit(); collectionFilter(); });

  /* ---------------- fit marking on theme product cards ---------------- */
  function fitsTags(tags, p) {
    if (!p) return null;
    if (!tags) return null;
    var t = ',' + tags.toLowerCase() + ',';
    if (t.indexOf(',fits-' + p.h + ',') > -1) return true;
    if (t.indexOf(',fits-universal,') > -1) return true;
    if (t.indexOf(',fits-magsafe,') > -1 && (p.brand === 'apple' || /^pixel-1[01]/.test(p.h))) return true;
    if (t.indexOf(',fits-') > -1) return false;
    return null;
  }
  GX.fits = fitsTags;
  function markCards() {
var p = GX.getPhone();
$$('[data-gx-tags]').forEach(function (card) {
var tags = card.getAttribute('data-gx-tags') || '';
var f = fitsTags(tags, p);
var want = (f === true && p && tags.indexOf('fits-' + p.h) > -1) ? '✓ Fits your ' + p.n.replace(/^(iPhone|Galaxy|Pixel) /, '') : '';
var old = $('.gx-fitdot', card);
if (want) {
if (!old) { old = d.createElement('span'); old.className = 'gx-fitdot'; old.textContent = want; card.appendChild(old); }
else if (old.textContent !== want) old.textContent = want;
} else if (old) { old.remove(); }
if ((f === false) !== card.classList.contains('gx-nofit')) card.classList.toggle('gx-nofit', f === false);
});
}
  d.addEventListener('click', function (e) {
var sw = e.target.closest && e.target.closest('.gx-fit-filter .gx-switch');
if (!sw) return;
e.preventDefault();
var v = sw.getAttribute('aria-checked') !== 'true';
store.set('gx_only_fits', v);
sw.setAttribute('aria-checked', v);
var bar = sw.closest('.gx-fit-filter'); if (bar) bar._gxHtml = bar.innerHTML;
d.body.classList.toggle('gx-hide-nofit', v);
});
function collectionFilter() {
  if (true) { d.body.classList.remove("gx-hide-nofit"); return; } /* superseded by gx-fitfilter.js */
    var grid = $('#ProductGridContainer') || $('.collection .product-grid') || $('[id^="ProductGrid"]');
    if (!grid || !$('[data-gx-tags]', grid)) return;
    var p = GX.getPhone(), bar = $('.gx-fit-filter');
    if (!bar) { bar = d.createElement('div'); bar.className = 'gx-fit-filter'; var host = grid.closest('.collection__content') || grid; host.parentNode.insertBefore(bar, host); }
    var html;
if (!p) { html = '<span>Want to see only what fits your phone?</span> <button type="button" class="gx-btn gx-btn--sm gx-btn--ink" data-gx-open-finder>Choose my phone</button>'; if (bar._gxHtml !== html) { bar.innerHTML = html; bar._gxHtml = html; } d.body.classList.remove('gx-hide-nofit'); return; }
var on = store.get('gx_only_fits') !== false;
html = '<button type="button" class="gx-switch" role="switch" aria-checked="' + on + '" aria-label="Only show accessories that fit"></button><span>Only show what fits my <b>' + esc(p.n) + '</b></span> <button type="button" class="gx-chip" data-gx-open-finder style="margin-left:auto">Change phone</button>';
if (bar._gxHtml !== html) { bar.innerHTML = html; bar._gxHtml = html; }
if (d.body.classList.contains('gx-hide-nofit') !== on) d.body.classList.toggle('gx-hide-nofit', on);
  }

  /* ---------------- product page: fit badge + auto-select model ---------------- */
  function pdpFit() {
    var el = d.getElementById('gx-product-json'); if (!el) return;
    var P; try { P = JSON.parse(el.textContent); } catch (e) { return; }
    var p = GX.getPhone();
    var host = $('.product__title') || $('h1');
    var badge = $('.gx-fitbadge');
    if (!badge && host) { badge = d.createElement('div'); host.parentNode.insertBefore(badge, host.nextSibling); }
    if (!badge) return;
    if (!p) { badge.className = 'gx-fitbadge gx-fitbadge--no'; badge.innerHTML = '📱 <button type="button" data-gx-open-finder>Check if this fits your phone</button>'; return; }
    var f = fitsTags(P.tags.join(','), p);
    var opt = -1;
    (P.options || []).forEach(function (o, i) { if (/model|phone|size|compatible|device/i.test(o)) opt = i; });
    var match = null;
    if (opt > -1) {
      P.variants.forEach(function (v) { if (!match && v.options[opt] === p.n && v.available) match = v; });
      if (!match) P.variants.forEach(function (v) { if (!match && v.options[opt] === p.n) match = v; });
    }
    if (match || f === true) {
      badge.className = 'gx-fitbadge'; badge.innerHTML = '✓ Fits your ' + esc(p.n) + ' · <button type="button" data-gx-open-finder>change</button>';
    } else if (f === false || opt > -1) {
      badge.className = 'gx-fitbadge gx-fitbadge--no'; badge.innerHTML = 'Not made for your ' + esc(p.n) + ' — <a href="/collections/' + p.h + '" style="color:inherit">see what fits</a> · <button type="button" data-gx-open-finder>change phone</button>';
    } else { badge.className = 'gx-fitbadge'; badge.innerHTML = '✓ Works with your ' + esc(p.n) + ' · <button type="button" data-gx-open-finder>change</button>'; }
    if (match && !P._auto) {
      P._auto = true;
      var form = $('form[action*="/cart/add"]');
      var cur = form && $('[name="id"]', form);
      if (cur && String(cur.value) === String(match.id)) return;
      var name = P.options[opt];
      var inputs = $$('input[type="radio"]').filter(function (i) { return i.value === p.n; });
      if (inputs.length) { inputs[0].click(); return; }
      $$('select').forEach(function (s) { $$('option', s).forEach(function (o) { if (o.value === p.n) { s.value = p.n; s.dispatchEvent(new Event('change', { bubbles: true })); } }); });
    }
  }

  /* ---------------- scroll progress ---------------- */
  function initProgress() {
    if (reduce) return;
    var bar = d.createElement('div'); bar.className = 'gx-progress'; bar.innerHTML = '<i></i>'; d.body.appendChild(bar);
    var i = bar.firstChild, tick = false;
    w.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () { var h = d.documentElement.scrollHeight - w.innerHeight; i.style.setProperty('--p', h > 0 ? w.scrollY / h : 0); tick = false; });
    }, { passive: true });
  }

  /* ---------------- boot ---------------- */
  function boot(scope) {
    initReveal(scope); initCounters(scope); initPointer(scope); initRails(scope); initAsyncRails(scope);
    initMarquee(scope); initStory(scope); initLab(scope); initFinders(scope);
  }
  function start() {
    d.documentElement.classList.add('gx-js');
    boot(d); paintChips(); markCards(); pdpFit(); collectionFilter(); initProgress();
    var mo = new MutationObserver(function (muts) {
      var hit = false;
      muts.forEach(function (m) { if (m.addedNodes.length) hit = true; });
      if (hit) { clearTimeout(mo._t); mo._t = setTimeout(function () { markCards(); collectionFilter(); }, 120); }
    });
    var target = $('#MainContent'); if (target) mo.observe(target, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
